export enum loginStateTypes {
  none = 0,
  error,
  mfaLogin,
  maintenance,
  error_static,
  error_dialog,
}
